import DatePickerRange from 'components/PeriodSelection/DatePickerRange';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';


export function EditSongVersionsExcerpts(songSplitsDetail: any) {

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(4);

    return (
        <>
            <div className='ws-12'>

                <div className="box-content ng-hide" data-ng-show="workTitlesDisplay">
                    <div className="form-horizontal form-condensed">

                        <div className="row-fluid">
                            <div className="table-responsive">
                                <div className="alert alert-info" ng-show="workTitles.length &lt;= 0">
                                    No versions or excerpts available for this song.
                                </div>
                                <table className="table ng-hide" ng-show="workTitles.length &gt; 0">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Type</th>
                                            <th>Language</th>
                                            <th>Original ISWC</th>
                                            <th>Writer1</th>
                                            <th>Writer2</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody> 
                                    </tbody>
                                </table>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    )

}